import { Facet, Sorting } from '../../search-spring/types/types'
import MobileFilter from './MobileFilter'
import MobileSortingFilter from './MobileSortFilter'

type Props = {
  filters: Facet[]
  sorting: Sorting
}

const MobileFilterFactory = ({filters, sorting}: Props): JSX.Element => {

  const ComponentHandler = (): JSX.Element => {
    const filteredFilter = CD_STATE.searchspring.filterIgnoreOptions.length ? filters.filter((filter) => !CD_STATE.searchspring.filterIgnoreOptions.includes(filter.field)) : filters

    if (filteredFilter.length) {
      return <>
        {filteredFilter.map((filter: Facet, index: number) => (
        <MobileFilter key={index} index={index} filter={filter} />
        ))}
      </>
    }
      return <div className="font-calibre text-base text-center p-3">
        If you are not seeing any results, try removing some of your selected filters.
      </div>
  }

  return (
    <div className="overflow-scroll">
      <ComponentHandler />
      <MobileSortingFilter sorting={sorting} />
    </div>
  )
}

export default MobileFilterFactory